export const list = {
  job_number: {
    name: '工号',
    key: 'job_number'
  },
  realname: {
    name: '姓名',
    key: 'realname',
    check: true
  },
  job: {
    name: '职位',
    key: 'job.job_name'
  },
  email: {
    name: '邮箱',
    key: 'email'
  },
  phone: {
    name: '电话',
    key: 'phone'
  },
  department: {
    name: '所属部门',
    key: 'department.name'
  },
};
